<template>
	<!-- 带弹窗的按钮 -->
	<div class="btn-modal-container">
		<AButton :type="type" :size="size" @click="openModal" :icon="icon">{{ btnText }}</AButton>
		<XModal ref="modal" v-bind="$attrs" v-on="$listeners" :title="title || btnText" :class="modalClass" :destroyOnClose="true" >
			<slot>
				<AEmpty description="暂无内容" />
			</slot>
			<template #footer>
				<slot name="footer"></slot>
			</template>
		</XModal>
	</div>
</template>
<script>
	export default {
		props: {
			/** 按钮文本 */
			btnText: {
				type: String,
				default: '弹窗按钮'
			},
			/** 按钮类型 */
			type: {
				type: String,
				default: 'primary'
			},
			/** 标题 */
			title: String,
			/** 按钮大小 */
			size: {
				type: String,
				default: 'default'
			},
			/** 打开窗口前置方法 */
			openBefore: Function,
			/** 按钮图标 */
			icon: String,
			/** 弹窗样式 */
			modalClass: String
		},
		data() {
			return {}
		},
		computed: {},
		methods: {
			/** 打开窗口 */
			async openModal() {
				//默认直接打开
				let open = true
				//存在前置方法 则前置方法需要返回true才能打开窗口
				this.openBefore && (open = await this.openBefore())
				if (!open) return
				this.$refs.modal.open()
			},
			/** 关闭窗口 */
			cancel() {
				this.$refs.modal.cancel()
			}
		}
	}
</script>
<style lang="less" scoped>
</style>
